"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardPhotoBody = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _PropertyCardPhotoBody = require("./PropertyCardPhotoBody.styles");
/**
 * A container for the property photo in a `PropertyCard`.
 *
 * @since 8.63.0
 */
var PropertyCardPhotoBody = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_PropertyCardPhotoBody.StyledPropertyCardPhotoBody, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.PropertyCardPhotoBody = PropertyCardPhotoBody;
PropertyCardPhotoBody.displayName = 'PropertyCard.PhotoBody';